// src/Components/Common/ChatButtonWithBadge.jsx
import React from 'react';
import ChatSidebar from './ChatSidebar';

const ChatButtonWithBadge = () => {
    // Le badge est maintenant géré directement dans ChatSidebar
    return <ChatSidebar />;
};

export default ChatButtonWithBadge;